import {BASIC_BED_PRICE} from './basicBedPricing.js';
export const BASIC_PROMO_CODE = 'BEDOCTOBER';
export const BASIC_PROMO_END = Date.parse('2026-11-01T00:00:00-05:00');
export function basicPromotion(code: unknown, productLine: string, units: number, now = Date.now()) {
  if (code === undefined || code === null || code === '') return undefined;
  if (typeof code !== 'string' || code.trim().toUpperCase() !== BASIC_PROMO_CODE) throw new Error('That checkout code is not valid.');
  if (productLine !== 'basic') throw new Error('BEDOCTOBER applies only to Bliss Basic base bunk sets.');
  if (now >= BASIC_PROMO_END) throw new Error('BEDOCTOBER expired October 31, 2026 at 11:59 p.m. Central.');
  if (!Number.isInteger(units) || units < 1) throw new Error('Choose a Bliss Basic bunk set first.');
  return {code:BASIC_PROMO_CODE, percent:25, units, savings:Math.round(BASIC_BED_PRICE * units * 25) / 100, expiresAt:new Date(BASIC_PROMO_END).toISOString()};
}
